import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//Ícones
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//Componentes
import { Link } from 'react-router-dom';
import GenericListPage from './GenericListPage';
//Controller
import QuestionarioController from '../controllers/QuestionarioController';
import PermissaoController from '../controllers/PermissaoController';
import { STATUS_RASCUNHO, STATUS_PUBLICADO, STATUS_DESATIVADO } from '../models/Questionario';

/**
 * Definindo o modelo Questionário
 * @typedef { import('../models/Questionario').default} Questionario
 */

//Página do recurso
class QuestionarioListPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleRenderItem = this.handleRenderItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        //Controllers
        this.questionarioController = new QuestionarioController();
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            permiteCadastrarQuestionario: false,
            titulo: '',
            status: ''
        };
    }

    async componentDidMount() {
        //Verifica se o usuário tem permissão para cadastrar um questionário
        const permiteCadastrarQuestionario = await this.permissaoController.permiteCadastrarQuestionario();
        this.setState({ permiteCadastrarQuestionario });
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Evento disparado para obter os parâmetros do filtros
     * @return {Object} Retorna os parâmetros informados pelo usuário
     */
    handleFilter() {
        //Recupera os parâmetros preenchidos pelo usuário
        const { titulo, status } = this.state;
        //Repassa os parâmetros para o filtro
        return { titulo, status };
    }

    /**
     * Renderiza os itens da lista
     * @param {Questionario} item 
     * @returns {React.Component} Retorna as colunas da listagem
     */
    handleRenderItem(item) {
        //Define o label do status do item
        let status = '-';
        if (item.modelo) 
            status = 'Modelo';
        else if (item.status === STATUS_RASCUNHO)
            status = 'Rascunho';
        else if (item.status === STATUS_PUBLICADO)
            status = 'Publicado';
        else if (item.status === STATUS_DESATIVADO)
            status = 'Desativado';

        let colunaDuplicar = null;
        if (this.state.permiteCadastrarQuestionario) {

            if (item.modelo)
                colunaDuplicar = (
                    <TableCell>
                        <IconButton aria-label="Duplicar" size="small" component={Link} to={`questionario/${item.id}/copia`}>
                            <FileCopyIcon />
                        </IconButton>
                    </TableCell>
                );
            else
                colunaDuplicar = (<TableCell></TableCell>);
        }

        //Renderiza na lista
        return (
            <React.Fragment>
                <TableCell>{item.titulo}</TableCell>
                <TableCell>{status}</TableCell>
                { colunaDuplicar }
            </React.Fragment>
        );
    }

    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { permiteCadastrarQuestionario, titulo, status } = this.state;
        const columnNames = ['Título', 'Status'];

        if (permiteCadastrarQuestionario)
            columnNames.push('Copiar');
        
        return (
            <GenericListPage resource="questionario" controller={this.questionarioController} readOnly={!permiteCadastrarQuestionario} columnNames={columnNames} onRenderItem={this.handleRenderItem} onLogout={onLogout} onFilter={this.handleFilter} usuario={usuario} empresa={empresa} permissoes={permissoes} >
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={8} lg={10} >
                                <TextField
                                    name="titulo"
                                    label="Título"
                                    type="text"
                                    placeholder="Título do questionário"
                                    variant="outlined"
                                    fullWidth
                                    value={titulo}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2} >
                                <FormControl fullWidth variant="outlined" >
                                    <InputLabel htmlFor="status">Status</InputLabel>
                                    <Select
                                        id="status"
                                        name="status"
                                        label="Status"
                                        native
                                        variant="outlined"
                                        fullWidth
                                        value={status}
                                        onChange={this.handleChange}
                                    >
                                        <option value=""></option>
                                        <option value={STATUS_RASCUNHO}>Rascunho</option>
                                        <option value={STATUS_PUBLICADO}>Publicado</option>
                                        <option value={STATUS_DESATIVADO}>Desativado</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} container justify="flex-end" >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </GenericListPage>
        );
    }
}

QuestionarioListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
};

export default QuestionarioListPage;